import { gql } from '@apollo/client';


export const GET_TICKET_SPEED_MEASUREMENT = gql`
  query GET_TICKET_SPEED_MEASUREMENT($ticketId: ID!, $originatorId: ID!){
    getTicket(ticketId: $ticketId, originatorId: $originatorId) {
      id
      speedMeasurement {
        id
        laserDisplayLightsAfter
        laserDisplayLightsBefore
        laserIdStr
        laserKnownDistanceAfter
        laserKnownDistanceBefore
        laserScopeAlignmentAfter
        laserScopeAlignmentBefore
        laserSelfAfter
        laserSelfBefore
        laserTimeAfter
        laserTimeBefore
        radarDisplayLightsAfter
        radarDisplayLightsBefore
        radarIdStr
        radarInternalCalibrationAfter
        radarInternalCalibrationBefore
        radarSpeedometerVerifAfter
        radarSpeedometerVerifBefore
        radarTimeAfter
        radarTimeBefore
        radarTuningForksAfter
        radarTuningForksBefore
      }
    }
  }
`;


